import Dashboard from '../pages/Dashboard';

const DashboardModule = {
  name: 'dashboard',
  label: 'Dashboard',
  Component: Dashboard,
};

export default DashboardModule;
